<template>
  <section class="container nsw-container mb-5">
    <div class="nsw-content-wrapper renewal-content-wrapper">
      <h1 v-if="step === 5">Thank you for your continued support</h1>
      <div class="sections-wrapper">
        <el-skeleton :rows="6" animated v-if="pageStatus === 'loading'" />
        <el-empty description="An error has occurred and we're unable to process your renewal" v-if="pageStatus === 'error'"></el-empty>
        <el-alert v-if="pageStatus === 'pending-payment'" title="A pending payment for dues already exists for this membership" type="info" show-icon center></el-alert>
        <el-result v-if="pageStatus === 'renewed-already'">
          <template slot="icon"><div></div></template>
          <template slot="extra">
            <div v-html="configSettings['renewal-already-paid']" />
          </template>
        </el-result>
        <template v-if="pageStatus === 'success'">
          <renewal-step v-if="step < 5" />
          <renewal-membership v-if="step === 1" />
          <renewal-donation v-if="step === 2" />
          <renewal-detail v-if="step === 3" />
          <renewal-payment v-if="step === 4" />
          <renewal-receipt v-if="step === 5" />
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import qs from 'query-string';

import RenewalStep from '../../components/FormRenewal/Step.vue';
import RenewalMembership from '../../components/FormRenewal/Membership.vue';
import RenewalDonation from '../../components/FormRenewal/Donation.vue';
import RenewalDetail from '../../components/FormRenewal/Detail.vue';
import RenewalPayment from '../../components/FormRenewal/Payment.vue';
import RenewalReceipt from '../../components/FormRenewal/Receipt.vue';

export default {
  components: {
    RenewalStep,
    RenewalMembership,
    RenewalDonation,
    RenewalDetail,
    RenewalPayment,
    RenewalReceipt
  },
  async mounted() {

    const eventUserSet = await this.initiateAuthAndSetEventUser()

    // todo: redirect to login or similar??
    if (!eventUserSet) {
      // return this.$router.push({ name: 'home' })
    }



    // const parsed = qs.parse(location.search);
    // const id = parsed.id ?? '';
    // const ck = parsed.ck ?? '';

    const token = this.parsedUrlParams.token || this.bearerToken || '';

    await this.getConfigurationSet({/* id, ck,*/ token});
  },
  computed: {
    ...mapState('auth', ['bearerToken', 'parsedUrlParams']),
    ...mapState({
      pageStatus: state => state.renewal.status,
      step: state => state.renewal.step,
      configSettings: state => state.renewal.configSettings,
    }),
  },
  methods: {
    ...mapActions('renewal', ['getConfigurationSet']),
    ...mapActions('auth', ['initiateAuthAndSetEventUser']),
  }
}
</script>

<style lang="scss">
  @import './style.scss';
</style>
